<template>
    <div>
        <button 
        class="fixed z-90 bottom-10 right-32 bg-white w-12 h-8 rounded-full drop-shadow-lg flex justify-center items-center text-eaze-blue text-4xl hover:drop-shadow-2xl">
        <slot/>
        </button>
    </div>
</template>